namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHdActColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoHdAct';
    }
}
